import React from "react"
import { Provider } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import store from "../services/auth"

import Layout from "../layout/layout"

import PrivateRoutes from "../routes/PrivateRoutes"
import PublicRoutes from "../routes/PublicRoutes"

const App = () => {
    return (
        <Provider store={store}>
            <Layout>
                <Routes>
                    <Route path="/"
                         element={<Navigate to="/home" replace />}>
                    </Route>
                    <Route path="/*" element={<PublicRoutes />} />
                    <Route path="/p/*" element={<PrivateRoutes />} />
                </Routes>
            </Layout>
        </Provider>
    )
}

export default App